import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindProductsStandardsRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindProductsStandardsRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindProductsStandardsRequestSortsDto>>
}

export const ProductStandardsSorts = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("products")

  return (
    <SortBuilder<FindProductsStandardsRequestSortsDto>
      options={[
        { label: t("sorts.name"), value: "name" },
        { label: t("sorts.brandReference"), value: "brandReference" },
        { label: t("sorts.purchaseOrder"), value: "purchaseOrder" },
        { label: t("sorts.brand"), value: "brand" },
        { label: t("sorts.color"), value: "color" },
        { label: t("sorts.brandType"), value: "brandType" },
        { label: t("sorts.collection"), value: "collection" },
      ]}
      sorts={sorts}
      setSorts={setSorts}
    />
  )
}
